import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllSpecialities = async (businessId?: string): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) throw new Error("User ID not found. Please log in again.");
    
    let url = `/specialities/all/${businessId}`;
   
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createSpeciality = async (branchData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/Specialities/create", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSpeciality = async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/specialities/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSpeciality = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/specialities/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
